import Enum from "models/enum";
import AuthorizationService from "../services/authorizationService";
import RepositoryBase from "./repositoryBase";
import { EnumContainer, IEnumRepository } from "@edaz/services/baseEnumService";
import { EnumTypes } from "../services/enumService";
import EventBus from "../services/eventBus";
import EshopRequestBuilder from "../data/eshopRequestBuilder";

export type SupportedEnumAPIVersions = 2 | 2.1 | 2.2 | 3.0;

export default class EnumRepository extends RepositoryBase<EshopRequestBuilder> implements IEnumRepository<Enum> {
  constructor(
    protected apiFactory: ReturnType<typeof EshopRequestBuilder.Factory>,
    protected authorizationService: AuthorizationService,
    protected eventBus: EventBus
  ) {
    super(apiFactory, authorizationService, eventBus);
  }

  getAll(enumName: EnumTypes, apiVersion: SupportedEnumAPIVersions = 2) {
    return this.callApi(api => api.apiVersion(apiVersion).all("enums").all(enumName).get<EnumContainer<Enum>>());
  }

  getEnum(enumName: EnumTypes, apiVersion: SupportedEnumAPIVersions = 2) {
    return this.getAll(enumName, apiVersion).then(result => {
      return result.items;
    });
  }

  async fetchEnums(): Promise<EnumContainer<Enum>> {
    const [countries, exemption_reasons, charge_validity_rules, fuel_types, charge_types] = await Promise.all([
      this.getEnum("countries", 3.0),
      this.getEnum("exemption_reasons", 3.0),
      this.getEnum("charge_validity_rules", 3.0),
      this.getEnum("fuel_types", 3.0),
      this.getEnum("charge_types", 3.0),
    ]);

    return {
      countries,
      exemption_reasons,
      charge_validity_rules,
      fuel_types,
      charge_types,
    };
  }
}
